import HeroBanner from "../components/HeroBanner";
import ServicesSection from "../components/sections/ServicesSection";
import AboutSection from "../components/sections/AboutSection";
import ProgressTrackerSection from "../components/sections/ProgressTrackerSection";
import TrustSectiion from "../components/sections/TrustSectiion";
import WhyChooseUs from "../components/sections/WhyChooseUs";
import useAppData from "../hooks/useAppData";

export default function Home() {
	const { homePage } = useAppData();
	return (
		<>
				<title>{homePage.meta_title}</title>
				<meta name="description" content={homePage.meta_description} />
				<meta name="keywords" content={homePage.meta_keywords} />
			<HeroBanner />
			<ServicesSection />
			<hr className="h-px bg-linear-to-r from-transparent via-gray-300 to-transparent border-0" />
			<AboutSection />
			<hr className="h-px bg-linear-to-r from-transparent via-gray-300 to-transparent border-0" />
			<WhyChooseUs />
			<ProgressTrackerSection />
			<div style={{ backgroundColor: "#dfdfdf" }}>
				<TrustSectiion />
			</div>
		</>
	);
}
